if (!window.Eurus.loadedScript.has('mobile-dock.js')) {
  window.Eurus.loadedScript.add('mobile-dock.js');
  
  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.store('xMobileDock', {
        showDock: false,
        resizeObserver: null,
        handlers: {},
        debounce(func, wait) {
          let timeout;
          return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
          };
        },
        initMobileDock() {
          const containerMobileDock = document.getElementById('mobile-dock-container');
          if (this.handlers.metrics) {
            window.removeEventListener('resize', this.handlers.metrics);
            window.visualViewport?.removeEventListener('resize', this.handlers.metrics);
            window.visualViewport?.removeEventListener('scroll', this.handlers.metrics);
          }
          if (this.handlers.scroll) window.removeEventListener('scroll', this.handlers.scroll);
          const updateMobileMetrics = () => {
            const viewportHeight = window.visualViewport?.height || window.innerHeight;
            document.documentElement.style.setProperty('--toku-visual-viewport-height', `${viewportHeight}px`);

            if (!containerMobileDock || window.xViewport.innerWidth >= 768) {
              document.documentElement.style.removeProperty('--toku-mobile-dock-height');
              return;
            }

            // The CSS variable already includes the fixed dock height and safe area.
            // Keep it as the single source of truth instead of measuring the element
            // back into the same variable, which can lock in a transient load height.
            document.documentElement.style.removeProperty('--toku-mobile-dock-height');
          };

          requestAnimationFrame(updateMobileMetrics);
          this.resizeObserver?.disconnect();
          if ('ResizeObserver' in window && containerMobileDock) {
            this.resizeObserver = new ResizeObserver(updateMobileMetrics);
            this.resizeObserver.observe(containerMobileDock);
          }
          this.handlers.metrics = this.debounce(updateMobileMetrics, 50);
          window.addEventListener('resize', this.handlers.metrics, { passive: true });
          window.visualViewport?.addEventListener('resize', this.handlers.metrics, { passive: true });
          window.visualViewport?.addEventListener('scroll', this.handlers.metrics, { passive: true });

          const header = document.getElementById('x-header-container');
          let headerBottom = document.getElementById('x-header-sentinel-bottom');
          const updateDock = () => {
            if (window.xViewport.innerWidth >= 768) {
              this.showDock = false;
              return;
            }
            if (!header) {
              this.showDock = true;
            } else {
              if (headerBottom) {
                const bottomLine = (Alpine.store('xHeaderMenu').isTransparent) ? headerBottom.getBoundingClientRect().bottom + Alpine.store('xHeaderMenu').stickyOffsetHeight : headerBottom.getBoundingClientRect().bottom;
                this.showDock = (bottomLine < 0);
              } else {
                headerBottom = document.getElementById('x-header-sentinel-bottom');
                this.showDock = true;
              }
            }
          }
          requestAnimationFrame(updateDock)
          this.handlers.scroll = this.debounce(updateDock, 50);
          window.addEventListener('scroll', this.handlers.scroll, { passive: true });
        },
        setPositionSearch() {
          const search = document.getElementById('FormSearchMobileDock');
          if (search) {
            const announcement = document.getElementById('x-announcement');
            let height;
            if (announcement) {
              let sticky = announcement?.dataset.isSticky == "true";
              height = sticky ? announcement?.offsetHeight : 0;  
            } else {
              height = 0;
            }
            search.style.setProperty('--announcement-height', `${height}px`);
          }
        }
      });
    });
  });
}
